import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  selector: {
    height: '100%',
    '& .MuiInputBase-input': {
      paddingTop: 10,
    },
  },
}));
